// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventDaysWithGamesListBody = {
  leagueId: string;
  fromDay: string;
  toDay: string;
  timeZone: string;
};

export type typeEventDaysWithGamesListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagueId: string;
    fromDay: string;
    toDay: string;
    timeZone: string;
    days: string[];
  };
};

export type typeEventDaysWithGamesListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventDaysWithGamesListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventDaysWithGamesListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventDaysWithGamesListBody = {
  type: "object",
  properties: {
    leagueId: { type: "string", maxLength: 3000, minLength: 1 },
    fromDay: { type: "string", maxLength: 3000, minLength: 1 },
    toDay: { type: "string", maxLength: 3000, minLength: 1 },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["leagueId", "fromDay", "toDay", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventDaysWithGamesList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventDaysWithGamesListBody);
  }

  return async function postEventDaysWithGamesList(
    payload: typeEventDaysWithGamesListBody,
  ): Promise<
    typeEventDaysWithGamesListOutput200 | typeEventDaysWithGamesListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventDaysWithGamesList" failed before calling the network. #606ac23c6cc4`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#606ac23c6cc4" },
        },
        data: null,
      } as typeEventDaysWithGamesListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/days-with-games-list`,
      httpMethod: "POST",
      options,
    })) as
      typeEventDaysWithGamesListOutput200 | typeEventDaysWithGamesListOutput400;
  };
}
